import { Formik, FormikProps } from 'formik';

import {
  Box,
  Button,
  DialogActions,
  Grid,
  TextField,
  Typography,
} from '@mui/material';

interface IProps {
  setGuestConfirmationCode: (passcode: string) => void;
  guestConfirmationCode: string;
  cancel: () => void;
  goNext: (answer: Record<string, string>, resend: boolean) => void;
  goBack: (answer: Record<string, string>, backToOptions: boolean) => void;
}

export default function MFAVerifyForm(props: IProps) {
  const {
    setGuestConfirmationCode,
    cancel,
    goNext,
    goBack,
    guestConfirmationCode,
  } = props;

  const setPasscode = (value: any) => {
    const val = value.replace(/\D+/g, '');
    setGuestConfirmationCode(val);
  };

  const goVerifyGuestLoginCode = (resend: boolean) => {
    const answer: Record<string, string> = {
      MFA: resend ? '' : guestConfirmationCode,
    };
    goNext(answer, resend);
  };

  const goBackToMFAOptions = (backToOptions: boolean) => {
    const answer: Record<string, string> = {
      MFA: '',
    };
    goBack(answer, backToOptions);
  };

  const renderForm = (formikProps: FormikProps<Record<string, string>>) => {
    const { handleSubmit } = formikProps;

    return (
      <form onSubmit={handleSubmit}>
        <Grid container justifyContent={'center'}>
          <h3>Please enter verification code</h3>
        </Grid>
        <Grid container justifyContent={'center'}>
          <TextField
            autoFocus
            value={guestConfirmationCode}
            onChange={(e) => setPasscode(e.target.value)}
            inputProps={{
              inputMode: 'numeric',
              pattern: '[0-9]*',
              maxLength: 6,
              autoComplete: 'off',
              style: { textAlign: 'center', fontSize: '20px', width: '80px' },
            }}
            type='text'
            variant='outlined'
          />
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              mt: '20px',
            }}>
            <Button
              size='medium'
              color='primary'
              onClick={() => goVerifyGuestLoginCode(true)}>
              RESEND CODE
            </Button>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              padding: '10px 0px',
            }}>
            <Box
              sx={{
                height: '1px',
                background: 'grey',
                width: '40px',
                marginRight: '10px',
              }}
            />
            <Typography variant='body1'>OR</Typography>
            <Box
              sx={{
                height: '1px',
                background: 'grey',
                width: '40px',
                marginLeft: '10px',
              }}
            />
          </Box>
          <Box
            sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <Button
              size='medium'
              color='primary'
              onClick={() => goBackToMFAOptions(true)}>
              BACK TO OPTIONS
            </Button>
          </Box>
          <DialogActions
            sx={{ justifyContent: 'space-between', width: '100%', mt: '30px' }}>
            <Button onClick={cancel} variant='outlined' color='primary'>
              CANCEL
            </Button>
            <Button
              disabled={guestConfirmationCode.length !== 6}
              type='submit'
              variant='contained'
              color='primary'>
              Verify
            </Button>
          </DialogActions>
        </Grid>
      </form>
    );
  };

  return (
    <Formik
      enableReinitialize
      validateOnChange={true}
      validateOnBlur={true}
      initialValues={{}}
      onSubmit={() => {
        goVerifyGuestLoginCode(false);
      }}>
      {renderForm}
    </Formik>
  );
}
